'use strict';

import _ from 'lodash';
import './ProductPreview.less';

import React from 'react';
import PropTypes from 'prop-types';
import Assets from 'ck-core-client/source/system/Assets';

export const ProductPreview = ({ videoFallbackName, videoName }) => {
	const asset = Assets.get(videoFallbackName);
	return (
		<div className="ProductPreview">
			<img
				src={_.get(Assets.get('product-preview-laptop'), 'url')}
				className="ProductPreview__laptop"
			/>
			{asset && (
				<video className="ProductPreview__video" loop muted autoPlay playsInline poster={asset.url}>
					<source
						src={CK.config.environment.clients.website.address + 'videos/' + videoName + '.webm'}
						type="video/webm"
					/>
					<source
						src={CK.config.environment.clients.website.address + 'videos/' + videoName + '.mp4'}
						type="video/mp4"
					/>
				</video>
			)}
		</div>
	);
};

ProductPreview.propTypes = {
	videoName: PropTypes.string.isRequired,
	videoFallbackName: PropTypes.string.isRequired
};
